export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.2-1033.00",
  commitId: "fdbe791901706b587d45219cb21b19e027af19ce",
  commitTime: "2026-09-02T10:33:00.000Z",
});
